<template>




 <div :id="id"
       class="sitebuilder-element-container"
       element="BlogPostComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()">


        <!-- <div v-if="show"> -->
            <theme-cool v-if="show &&type == 'post'" :options="allOptions"></theme-cool>
            <theme-author v-if="show && type == 'author'" :options="allOptions"></theme-author>
        <!-- </div> -->

         






</div>

  
</template>

<script>

import elementData from './Model';
import ThemeCool from './themes/Cool.vue';
import ThemeAuthor from './themes/Author.vue';
import axios from 'axios';
import moment from 'moment/moment';



export default {
    name: 'BlogPostComponent',
    props: ['config', 'id'],
    components : {  ThemeCool, ThemeAuthor },
     data() {
			return elementData.data();
    },
    methods: {

        build(config) {
            this.internal_config = config;
        },
         animation() {
        return false;
        },

        style(){
           let {
        left,
        zIndex,
        paddingTop,
        paddingLeft,
        paddingRight,
        paddingBottom,
        top
      } = this.internal_config;

      let style = `
                     left:  ${left};
                     z-index: ${zIndex};
                     max-width: ${this.internal_config.maxWidth};
                     width: ${this.internal_config.width};
                     margin: 0 auto;
                     padding-top: ${paddingTop};
                     padding-left: ${paddingLeft};
                     padding-right: ${paddingRight};
                     padding-bottom: ${paddingBottom};
					 top: ${top}`;

      return style; 
        },

        getkey(){


        let vm = this;

          let url = '';
          if(window.location.host == 'publication.localhost' || window.location.host == 'localhost:8080') {
              url = 'http://blog.localhost/get-key?&website_id=MQ==';
          }else{
              let url = 'https://blog-beta.omb11.com/get-key?website_id=' + window.OPTIONS_INIT_SITE.options.w_code

          }

        



        axios.get(url)
        .then((res) => {
            this.viewConfig = res.data;

             if(localStorage.getItem('utc_time_' + this.viewConfig.key) == null){
                    localStorage.setItem('utc_time_' + this.viewConfig.key, moment().utc().unix());
             }

              //verifica se é pagina de author
              if(window.location.pathname.indexOf('/author/') !== -1){
                  this.type = 'author'
              }else{
                this.type = 'post'
              }


                  // this.type = 'author'

            this.type == 'post' ? vm.getPost(this.viewConfig.key) : vm.getAuthor(this.viewConfig.key);
      
        })

    },


    getAuthor(){
      let author = window.location.pathname.replace('/author/', '');
      let  url = '/cheetah/blog/get-author?author=' + author;
      
      if(window.location.host == 'localhost:8080'){
             url = 'http://publication.localhost/cheetah/blog/get-author?author=alan';
      }

 
      let vm = this;

      

      axios.get(url)
      .then( ({ data }) => {
         this.show = true;
         this.author = data;

            //get posts
            if(window.location.host == 'publication.localhost' || window.location.host == 'localhost:8080'){
                url = 'http://blog.localhost/get-news?perpage='+ 30 +'&page=' + 1 + '&website_id=MQ==';
            }else{
                url = 'https://blog-beta.omb11.com/get-news?perpage='+ 30 +'&page=' + 1 + '&website_id=' + window.OPTIONS_INIT_SITE.options.w_code;
            }

            url = url + '&author=' + author;

            axios.get(url)
            .then( ({ data }) => {
              vm.posts = data.data
                this.resize();
            });

      } )
    },

    getPost(key = false){

         let url = '?post=' + window.location.pathname.replace('/', '')
        if(key){
            url = url + '&utc_time=' + localStorage.getItem('utc_time_' + key);
        }

        let vm = this;

        let elementBounding = vm.$el.getBoundingClientRect();
				let top = $(vm.$el).position().top;
				let left = $(vm.$el).offset().left;
        let width = elementBounding.width;

        url = '/cheetah/blog/get-new' + url 

         if(window.location.host == 'publication.localhost' || window.location.host == 'localhost:8080'){
            url = 'http://publication.localhost//cheetah/blog/get-new?post=meu-novo-post';
        }

      
        let originalHeingEl = $(vm.$el).height();

         this.show = true;
       


     axios.get(url )
      .then( (res) => {


      this.post = res.data;
      this.resize();

         //register access
          let url_access = '';
        if(window.location.host == 'publication.localhost'){
            url_access = 'http://blog.localhost/register-view/';
        }else{
            url_access = 'https://blog-beta.omb11.com/register-view/';
        }

        url_access = url_access + window.location.pathname.replace('/', '') + '?website_id=' + window.OPTIONS_INIT_SITE.options.w_code



        if(localStorage.getItem('url_view_' + this.post.url) == null){
                localStorage.setItem('url_view_' + this.post.url, true);
                url_access = url_access + '&first=true'
             }

            axios.get(url_access)
              .then( response => console.log(response) )

              $('p>img').each( function(i, p){ 
                let p2 = ($(p).parent()) 
                if(p2.height() == 0){ $(p2).css('height', p.height) }
                }  )
          setTimeout(function(){
              $('p>img').each( function(i, p){ 
                let p2 = ($(p).parent()) 
                if(p2.height() == 0){ $(p2).css('height', p.height) }
                } )

              $('p>img').css('max-width', '100%');
              $('.ql-video').css('max-width', '100%');
              $('.ql-video').css('pointer-events', 'visible');
              $('a').removeAttr('rel');
              $('.content-post > iframe').css('max-width', '100%')
              $('.content-post > p > iframe').css('max-width', '100%')



              vm.resize();
           
             

        }, 1000)
      
     
    })

    },
    resize(){
        let vm = this;

      let elementBounding = vm.$el.getBoundingClientRect();
				let top = $(vm.$el).position().top;
				let left = $(vm.$el).offset().left;
        let width = elementBounding.width;
      
        let originalHeingEl = $(vm.$el).height();


            let valueChanged =  $(vm.$el).height() - 300;
          

            if(valueChanged > this.valueChanged){
                this.valueChanged = valueChanged;
              if (typeof vm.$parent.$parent.changeHeight !== 'undefined') {
                // vm.$parent.$parent.changeHeight(valueChanged, true, vm.$parent.id, top, left, width);
              } else {
                vm.$parent.changeHeight(valueChanged, true, vm.$parent.id, top, left, width, true);
              }
            }
    },
    },
      created() {
        let device, childs, id, config;
        ({ device, childs, id, config } = this.$props);
        this.internal_config = config;
        this.device = device;
        if (typeof id !== "undefined") {
            this.id = id;
        }
        this.internal_config = window.mergeRecursive(
        this.props,
        this.$props.config
        );
  },
  mounted(){


        let vm = this;



       
        this.getkey();


          setInterval(() => {
            vm.resize();
          }, 1000);
        // setTimeout(function(){
        //       vm.resize();
        // }, 2000)

         this.build(this.$props.config);
         this.$root.$on('setConfigElement', (id, obj) => {
            if(this.id == id){
            this.config = obj;
            this.internal_config = obj;
            }
        });


         let objIds = [];
            $("[id]").each(function() {
            var ids = $('[id="' + this.id + '"]');
            if (ids.length > 1 && ids[0] == this && parseInt(this.id))
                objIds.push(this.id);
            });
        if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
        }
  },
  computed: {
    allOptions() {

   // START TITLESTYLE

         let titleStyle = `font-family:  ${this.internal_config.titleStyle.family};
                  font-size: ${this.internal_config.titleStyle.size};
                  text-align: ${this.internal_config.titleStyle.align};
                  font-weight: ${this.internal_config.titleStyle.weight};
                  font-style: ${this.internal_config.titleStyle.style};
                  text-decoration: ${this.internal_config.titleStyle.stroke};
                  color: ${this.internal_config.titleStyle.color}`;

      this.post.date_show = moment(String(this.post.created_at)).format(this.internal_config.dateFormat)

      return {
        post: this.post,
        author: this.author,
        posts: this.posts,
        titleStyle              : titleStyle,
        colorDetails            : this.internal_config.colorDetails,
        cardBgColor             : this.internal_config.cardBgColor,
      }
    }
  }
}
</script>

<style>

[element="BlogPostComponent"] .vdr {
    height: auto !important;
}

.img-responsive {
    max-width: 100% !important;
}

</style>